



(function($){

// hideheader();
var scrollingup=false;
var menushowing=true;
var lastScrollTop = 0;
var fixmenu=160;
var scrollStart = $(this).scrollTop();

// function hideheader(){
// console.log("hideheader");
// var elm=document.getElementsByTagName("html")[0];
// elm.style.display="none";
// // document.addEventListener("DOMContentLoaded",function(event) {elm.style.display="block"; });
// }

// var pagehero = document.querySelector('.animated-hero');
window.onload = function() {
           hasScrolled();
           // heroDelay();
};





function heroDelay(){
    // console.log('hero delay');
    setTimeout(function() {
    heroAnimation();
  }, 500 );
}
function heroAnimation(){
    var isHomepage = document.getElementsByClassName('animated-hero');
if (isHomepage.length > 0) {
      pagehero.classList.add('ani-start'); 
}

}




function noBanner(){
    // console.log("no banner on page");
    var $menufloat = $('body').find('.wp-block-group.menu');
    if ($menufloat!= null) {
    $menufloat.addClass('menu-float');
    $menufloat.removeClass('menu-land');
    }
  
 }


function menuFloat(){
     var $menufloat = $('body').find('.wp-block-group.menu');
    if ($menufloat!= null) {
    $menufloat.addClass('menu-float');
    $menufloat.removeClass('menu-land');
    $menufloat.addClass('fadein');
    $menufloat.removeClass('fadeout');
    }

  
 }

function menuLand(){
    // console.log("menuland");
  // if( $("header").hasClass( "ctrl-noheader" ) ){
  //           noBanner();
  //   }

  //   else {
    var $menuland = $('body').find('.wp-block-group.menu');
    if ($menuland!= null) {
    $menuland.addClass('menu-land');
      $menuland.removeClass('menu-float');
      // $menuland.removeClass('bg-white');
    // }
    }
  

    
}
function menuAppear(){
  // console.log('menuAppear');
  menushowing=true;
var $showmenu = $('body').find('.wp-block-group.menu');
if ($showmenu!= null) {
   $showmenu.addClass('fadein');
    $showmenu.removeClass('fadeout');
     // $showmenu.addClass('bg-white');
}
    
var $showlogo = $('body').find('.wp-block-group.logo');
  if ($showlogo!= null) {
      $showlogo.addClass('fadein');
    $showlogo.removeClass('fadeout');
    }
  
   
}

function menuDisappear(){
    // console.log('menuDisappear');
  menushowing=false;
  var $hidemenu = $('body').find('.wp-block-group.menu');
   if ($hidemenu!= null) {
    $hidemenu.removeClass('fadein');
    $hidemenu.addClass('fadeout');
    // $hidemenu.removeClass('bg-white');
   }
    
}
function hasScrolled() {
    var st = $(this).scrollTop();
    var windowsize = $(window).width();
    var hideNum = 456;



//mobile
if (windowsize < 979)  {
     menuFloat();
   }
else {
    //desktop

     if (lastScrollTop > fixmenu){   
   menuFloat();
   }
  }
 if(st<=lastScrollTop){
    scrollingup=true;
          // console.log('scrolling up' );
          // console.log('st = ' + st );
          // console.log('hideNum'+ hideNum );
   
          if (menushowing==false){
             menuAppear();
          }
    
          //if section nav is open then close it
 
     if  (lastScrollTop > fixmenu){
      menuFloat();
        }
        else {
            menuLand();
        }
     if (st > hideNum){
   
     }
        
     //scrolling up
      
  }


  else if(st>lastScrollTop){
        //scrolling down
      scrollingup=false;
      //used if we want sidenav to change colour on scroll
     
     
     if (st > hideNum){
         menuDisappear();
     }
        
   

    
      
     

  }
  lastScrollTop = st;  


}





$(window).on('scroll', function() {
hasScrolled();
});

})(jQuery);

// document.addEventListener('DOMContentLoaded', () => {
//   const fadeSections = document.querySelectorAll('.fade-in-right');
//   const observerOptions = {
//     root: null, // viewport as the root
//     rootMargin: '0px',
//     threshold: 0.1 // Trigger when 10% of the element is visible
//   };

//   const observer = new IntersectionObserver((entries, observer) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add('is-visible');
//         observer.unobserve(entry.target); // Stop observing once visible
//       }
//     });
//   }, observerOptions);

//   fadeSections.forEach(section => {
//     observer.observe(section);
//   });
// });

//triggers animations on blocks (css)
document.addEventListener('DOMContentLoaded', () => {
  const animatedElements = document.querySelectorAll('.animated-element');
  const observerOptions = {
    root: null, // observe against the viewport
    rootMargin: '0px',
    threshold: 0.3 // Trigger when 20% of the element is visible
  };

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Element is in the viewport, add the class to trigger animations
        entry.target.classList.add('in-viewport');
        // Optionally, stop observing after the animation is triggered once
        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  animatedElements.forEach(element => {
    observer.observe(element);
  });
});